<template lang="pug">
.audit-sub-item-content(v-loading="loading")
  .audit-sub-item-content__header(:class="[showQuotation && data.status === 1 ? 'content__extend' : 'content__collapse']")
    .content-header__action
      span {{ data.vendor_name }}
      div
        template(v-if="data.status === 0 && data.price_empty && (data.approve_status === 0 || data.approve_status === 4)")
          span.status__pending {{ $t('待上传') }}
        template(v-else)
          template(v-if="!isNeedIT")
            span.status__pending(v-if="data.approve_status === 0") {{ $t('待审核') }}
            span.status__approve(v-else-if="data.approve_status === 1") {{ $t('已通过') }}
            span.status__reject(v-else-if="data.approve_status === 2") {{ $t('已拒绝') }}
          template(v-else)
            span.status__pending(v-if="data.approve_status !== 2 && (data.it_approve_status === 0 || data.it_approve_status === 2)") {{ $t('待IT审核') }}
            span.status__pending(v-else-if="data.it_approve_status === 1 && data.approve_status === 0") {{ $t('待审核') }}
            span.status__approve(v-else-if="data.it_approve_status === 1 && data.approve_status === 1") {{ $t('已通过') }}
            span.status__reject(v-else-if="data.approve_status === 2") {{ $t('已拒绝') }}
        div
          el-button(
            :disabled="!canUserEditCampaign || !canAudit"
            type="primary"
            @click="onConfirm"
          ) {{ $t('通过') }}
          el-button(
            :disabled="!canUserEditCampaign || !canAudit"
            type="primary"
            @click="onReject"
          ) {{ $t('拒绝') }}
    .content-header__attachment(v-if="data.status === 1")
      .header-attachment__right
        div
          span {{ $t('方案') }}：
          uploaded-file-display(
            :fileName="data.project_name"
            :downloadUrl="data.project_download_path"
          )
        div(v-if="tabTableData && tabTableData.vendor_price.some(v => v.category_id === 3)")
          span {{ $t('广告物料制作审批邮件') }}：
          uploaded-file-display(
            :fileName="data.approve_email_file_name"
            :downloadUrl="data.approve_email_download_url"
          )
        div(v-if="data.kol_path != null")
          span {{ $t('KOL') }}：
          uploaded-file-display(
            :fileName="data.kol_name"
            :downloadUrl="data.kol_download_path"
          )
          i.iconfont.icon-baojia1(
            @click="visible = true"
          )
      .header-attachment__left
        span(v-if="tabTableData") {{ tabTableData.summary.grand_total | formatMoney }}
      el-button.show-quotation-button(
        :disabled="data.status === 0"
        @click="viewQuotation"
        type="text"
        :class="[showQuotation ? 'content__extend' : 'content__collapse']"
      ) {{ $t('报价明细') }}
        i.el-icon--right.el-icon-arrow-down
  .audit-sub-item-content__quotation(v-if="showQuotation && data.status === 1")
    quotation-tab-table(
      v-if="tabTableData"
      :data="tabTableData"
    )
    .quotation-remark-container
      template(v-if="canAudit")
        el-button(
          v-if="!showRemarkField"
          @click="showRemarkField = true"
        ) {{ $t('添加备注') }}
        template(v-if="showRemarkField")
          el-input(
            :disabled="!canUserEditCampaign || !canAudit"
            v-model="remark"
            type="textarea"
            :rows="5"
            style="width: 600px"
            :placeholder="$t('备注不多于500字')"
            :class="{'has-error': errors.has('remark_field') }"
            v-validate="'max:500'"
            data-vv-as="remark_field"
            name="remark_field"
          )
          p(class="input-error") {{ errors.first('remark_field') }}
      el-row(v-else)
        el-col(:span="1" style="width: 35px" v-if="isZh") {{ $t('备注') }}:
        el-col(:span="1" style="width: 50px" v-else) Remark:
        el-col(:span="20")
          .remark-container {{ remark == null || remark === '' ? '—' : remark }}
  kol-quotation-reference-dialog(
    v-if="visible"
    :visible="visible"
    :subFinalScopeVendorId="data.sub_final_scope_vendor_id"
    @cancel="visible = false"
  )
</template>

<script>
import KolQuotationReferenceDialog from '@/components/KolQuotationReferenceDialog'
import UploadedFileDisplay from '@/components/UploadedFileDisplay'
import axios from 'axios'
import QuotationTabTable from './QuotationTabTable'
import { formatMoney, numberWithCommas, formatDate } from '@/umcc/util'
import DisplayTextContainer from '@/components/DisplayTextContainer'
import db from '@/umcc/db'

export default {
  components: {
    QuotationTabTable,
    KolQuotationReferenceDialog,
    DisplayTextContainer,
    UploadedFileDisplay
  },
  computed: {
    showQuotation () {
      return this.$store.state.campaign.quotationExtendOrder[this.parentIndex + '.' + this.index]
    },
    isItUser () {
      return this.$route.path === '/campaign/it-audit-quotation'
    },
    canAudit () {
      const { approve_status: a, it_approve_status: it } = this.data
      if (this.data.status === 0) return false
      if (this.isView) return false
      if (this.isItUser) return it === 0
      if (this.isNeedIT) return a === 0 && it === 1
      if (!this.isNeedIT) return a === 0
      return false
    },
    campaignId () {
      return this.$store.state.campaign.id
    },
    taskName () {
      return this.$store.state.campaign.taskName
    },
    activePhaseType () {
      return this.$store.state.campaign.activePhaseType
    },
    phaseType () {
      return this.$store.state.campaign.phaseType
    },
    isZh () {
      return db.lang === 'zh'
    }
  },
  filters: {
    numberWithCommas,
    formatMoney,
    formatDate,
    DisplayTextContainer
  },
  data () {
    return {
      visible: false,
      tabTableData: null,
      remark: '',
      canUserEditCampaign: false,
      loading: false,
      showRemarkField: false
    }
  },
  props: {
    data: {
      type: Object,
      default () {
        return {}
      }
    },
    isNeedIT: {
      type: Boolean,
      default () {
        return false
      }
    },
    parentIndex: {
      type: Number,
      default () {
        return 0
      }
    },
    index: {
      type: Number,
      default () {
        return 0
      }
    }
  },
  mounted () {
    this.fetchTableData()
    this.checkCanUserEditCampaign()
    if (!this.canAudit) { this.fetchRemark() }
  },
  methods: {
    checkCanUserEditCampaign () {
      axios
        .get('/common/canEditCampaign', {
          params: {
            campaign_id: this.campaignId,
            task_name: this.taskName
          }
        })
        .then((res) => {
          this.canUserEditCampaign = res.can_edit
        })
    },
    fetchTableData () {
      this.loading = true
      const status = this.isNeedIT ? this.data.it_approve_status : this.data.approve_status
      let axiosUrl = ''
      switch (status) {
        case 1:
          axiosUrl = '/management/subfinal/getApprovedVendorQuotation'
          break
        default:
          axiosUrl = '/management/subfinal/getVendorQuotation'
          break
      }
      axios
        .get(axiosUrl, {
          params: {
            sub_final_scope_vendor_id: this.data.sub_final_scope_vendor_id,
            phase_current: this.activePhaseType,
            phase_reality: this.phaseType
          }
        })
        .then((res) => {
          if (res.task_id != null && this.$store.state.campaign.taskId == null) {
            this.$store.commit('campaign/setTaskId', res.task_id)
          }
          this.tabTableData = res
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          throw new Error(err)
        })
    },
    onConfirm () {
      this.$validator.validate().then(result => {
        if (result) {
          this.handleAudit('confirm')
        }
      })
    },
    onReject () {
      this.$validator.validate().then(result => {
        if (result) {
          this.handleAudit('reject')
        }
      })
    },
    handleAudit (result) {
      this.loading = true
      const params = {
        sub_final_scope_vendor_id: this.data.sub_final_scope_vendor_id,
        approve_type: 2,
        business_type: 4,
        approve_result: result === 'confirm' ? 1 : 2,
        task_name: this.$store.state.campaign.taskName,
        task_id: this.$store.state.campaign.taskId,
        campaign_id: this.$store.state.campaign.id
      }
      if (this.remark !== '') {
        params.remark = this.remark
      }
      axios
        .get('/management/subfinal/approveSingleVendorPrice', {
          params: params
        })
        .then(() => {
          this.fetchTableData()
          this.$emit('update')
          if (result === 'reject') {
            this.showQuotation = false
          }
          this.loading = false
        })
    },
    viewQuotation () {
      const qeo = this.$store.state.campaign.quotationExtendOrder
      this.$set(qeo, this.parentIndex + '.' + this.index, !this.showQuotation)
    },
    fetchRemark () {
      axios
        .get('/management/subfinal/getApprovePriceRemark', {
          params: {
            sub_final_scope_vendor_id: this.data.sub_final_scope_vendor_id
          }
        })
        .then((res) => {
          this.remark = this.isNeedIT ? res.it_remark : res.remark
        })
    }
  }
}
</script>

<style lang="stylus">
.audit-sub-item-content
  border 1px solid #d8d8d8
  margin 24px 32px
  .el-button--primary.is-disabled
    background #eeeeee
    border-color #eeeeee
    color $disabled
.audit-sub-item-content__header
  background #fafafa
  padding 12px 24px
  &.content__extend
    border-bottom 1px solid #d8d8d8
.content-header__action
  display flex
  justify-content space-between
  align-items center
  > span
    font-size 16px
    color #2c3031
  > div
    display flex
    align-items center
    > span
      margin-right 12px
    .status__pending
      color #ffc174
    .status__approve
      color #66dab5
    .status__reject
      color #f66c62
    .status__uploading
      color red
    .el-button
      font-weight normal
.content-header__attachment
  display flex
  justify-content space-between
  position relative
.header-attachment__right
  > div
    margin 8px 0
    display flex
    align-items center
    > span
      color #808080
    > i
      color $main
      margin-left 8px
      cursor pointer
    > a
      color $main

.header-attachment__left
  align-self flex-end
  margin-right 100px
  > span
    display block
    color #2c3031
    font-size 20px
    margin 8px 0
.show-quotation-button
  position absolute
  bottom -10px
  right 0
  font-weight normal
  font-size 14px
  &.content__extend i
    transform: rotateZ(0deg)
    transition transform .3s
  &.content__collapse i
    display inline-block
    transform: rotateZ(180deg)
    transition transform .3s
.quotation-remark-container
  position relative
  padding 16px 24px
  border-top 1px solid #d8d8d8
  background #fafafa
  .el-row
    margin 0
    .el-col
      color $font-color
      &:first-child
        margin-right 8px
    .remark-container
      font-size 12px
      width 600px
      word-break break-word
  textarea.el-textarea__inner
    height auto

</style>
